import { Button } from "@components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Label } from "@components/ui/label";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";
import { updateJobRequirement } from "@endpoints/hiringCompany/requirements";
import { useSnackbar } from "notistack";
import { SetStateAction, useState } from "react";
import { useParams } from "react-router-dom";

type CloseJobDialogProps = {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<SetStateAction<boolean>>;
  onConfirmed: (value: number) => void;
};

const CloseJobDialog = (props: CloseJobDialogProps) => {
  const { openDialog, setOpenDialog, onConfirmed } = props;
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const [selectedOption, setSelectedOption] = useState("");
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    try {
      setIsConfirming(true);
      const { data, success } = await updateJobRequirement({
        id,
        closeReason: parseInt(selectedOption),
      });
      if (success) {
        enqueueSnackbar("Job closed successfully", { variant: "success" });
        onConfirmed && onConfirmed(data?.closeReason);
        setOpenDialog(false);
      }
    } catch (error) {
      console.error("Error: error closing the job requirement", error);
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <Dialog open={openDialog} onOpenChange={setOpenDialog}>
      <DialogContent className="bg-white w-[340px] max-w-[340px]">
        <DialogHeader>
          <DialogTitle className="text-sm leading-[1.2rem]">
            Please choose a reason for job closure
          </DialogTitle>
        </DialogHeader>
        <div className="flex gap-4 my-2">
          <RadioGroup onValueChange={(value) => setSelectedOption(value)}>
            <div className="flex items-center gap-3">
              <RadioGroupItem value="1" id="r1" />
              <Label className="text-xs" htmlFor="r1">
                No Longer Required
              </Label>
            </div>
            <div className="flex items-center gap-3">
              <RadioGroupItem value="2" id="r2" />
              <Label className="text-xs" htmlFor="r2">
                Job Requirement Fulfilled
              </Label>
            </div>
          </RadioGroup>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            disabled={!selectedOption}
            isLoading={isConfirming}
            onClick={handleConfirm}
            type="submit"
            className="text-white"
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CloseJobDialog;
